import { createBrowserRouter } from 'react-router-dom';

import { BASE_PATH } from 'src/constants';
import { routes } from 'src/router/routes';

export const router = createBrowserRouter(routes, { basename: BASE_PATH });
